export class LocalStorageNotFoundError extends Error {
  constructor() {
    super('LOCAL_STORAGE_NOT_FOUND');
  }
}
